import { Injectable } from '@angular/core';
import { OrgQuery } from '@y42/org/state';
import { UserQuery } from '@y42/user/state';

declare const window: Window & {
  analytics: {
    identify: (id: string, data: unknown) => unknown;
  };
};

/**
 * TODO: figure out if this service is still necessary.
 * If yes, figure out a better place and name for it.
 */
@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  constructor(private readonly orgQuery: OrgQuery, private readonly userQuery: UserQuery) {}

  init() {
    const activeOrg = this.orgQuery.getActive();
    const activeUser = this.userQuery.getActiveUser();

    if (activeUser) {
      let data = {
        user_id: `${activeUser.id}`,
        name: activeUser.full_name,
        email: activeUser.email,
        widget: { activator: '#intercom' },
        hide_default_launcher: true,
        unsubscribed_from_emails: false,
        company: {},
        'Onboarding Role': undefined,
        'Onboarding Skill Level': undefined,
      };

      if (activeOrg) {
        data = {
          ...data,
          company: {
            id: activeOrg.id.toString(),
            name: activeOrg.name,
          },
        };
      }

      window.analytics.identify(`${activeUser.id}`, data);
    } else {
      console.error(`[GoogleAnalyticsService]: could not init because no active user`);
    }
  }
}
